import { Record } from "immutable";

export type TagType = {
  id?: string;
};

const defaultTag: TagType = {
  id: undefined
};

export default class Tag extends Record(defaultTag) {}
